// Asks the server (netlify/functions/school-invite-email.ts) to email a
// school's invitation to the teacher. Sends only the invitation id and the
// admin's own sign-in token; the server checks everything else.
export async function sendSchoolInvitationEmail(
  invitationId: string,
  accessToken: string,
): Promise<boolean> {
  try {
    const response = await fetch('/api/school/invite-email', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ invitationId }),
    });
    return response.ok;
  } catch {
    return false;
  }
}

export type SchoolRequestEmailKind = 'new_request' | 'decision';

// Asks the server (netlify/functions/school-request-email.ts) to email about
// a school account request: staff when a leader asks, the leader when staff
// decide. Best effort -- the request and decision are already saved, so a
// failed email never undoes or blocks them.
export async function sendSchoolRequestEmail(
  requestId: string,
  kind: SchoolRequestEmailKind,
  accessToken: string,
): Promise<boolean> {
  try {
    const response = await fetch('/api/school/request-email', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ requestId, kind }),
    });
    return response.ok;
  } catch {
    return false;
  }
}
